import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["replicationGroupSelect", "unnamedCheckbox"];

  submit() {
    const url = new URL(window.location.href);
    const currentParams = new URLSearchParams(url.search);
    const newParams = new URLSearchParams();

    const searchParam = currentParams.get("search");
    if (searchParam) {
      newParams.set("search", searchParam);
    }
    if (this.replicationGroupSelectTarget.value) {
      newParams.set("replication_group_id", this.replicationGroupSelectTarget.value);
    }
    if (this.unnamedCheckboxTarget.checked) {
      newParams.set("unnamed", "true");
    }

    window.location.href = `${window.location.pathname}?${newParams.toString()}`;
  }
}
